<template>
    <div>
        <!-- Remove the leave bg -->
        <!-- <div class="top-wave leaf-home"></div>
        <div class="bottom-wave leaf-bottom"></div>
        <div class="second-wave"></div> -->

        <div class="cont-land">
            <div class="top-blob"></div>
            <!--<div class="lines-right"></div>-->
            <!-- <div class="lines-bottom"></div> -->
            <img src="/images/golden-pose-1.png" class="scuirel-top-1" alt="" />
            <!--
            <img src="/images/ice_age_top_3.png" class="scuirel-top-3" alt="" />
            <img src="/images/ice_age_top_2.png" class="scuirel-top-2" alt="" />
            <img src="/images/ice_age_top_4.png" class="scuirel-top-4" alt="" />
            -->
            <!-- <b-container fluid> -->
            <div class="container-fluid first-wave">
                <div class="cont-section">
                    <b-row no-gutters class="row-section">
                        <b-col cols="12">
                            <div class="sub-title-sections text-left">
                                Thetanuts protocol helps participants gain
                                sustainable yield through crypto structured
                                products.
                            </div>
                        </b-col>
                        <!-- <b-col cols="12">
                            <div class="btn-section">
                                <router-link to="/vaults">
                                    <button
                                        class="btn btn-primary btn-home"
                                        type="button"
                                    >
                                        START EARNING
                                    </button>
                                </router-link>
                                <button
                                    class="btn btn-secondary btn-home"
                                    type="button"
                                    style="padding: 0 15px; margin: auto"
                                    >
                                    Trade Now
                                </button>
                            </div>
                        </b-col> -->
                        <b-col cols="12" class="item-list-box text-left">
                            <stat-item :itemList="itemStats"></stat-item>
                        </b-col>
                    </b-row>
                </div>

                <!-- <div class="first-wave"> -->
                <!--
                <div class="cont-section-2">
                    <b-row no-gutters class="row-section-2">
                        <b-col cols="12">
                            <banner-box :itemBanner="itemBanTwo"></banner-box>
                        </b-col>
                    </b-row>
                </div>
                -->
                <div class="cont-section-2">
                    <b-row no-gutters class="row-section-2">
                        <b-col cols="12">
                            <div class="title-section-2">featured vaults</div>
                        </b-col>
                        <b-col
                            cols="12"
                            class="box-fault"
                            style="padding-left: 5%; padding-right: 5%"
                        >
                            <feature-fault
                                v-if="vaults"
                                :items="getFeatured"
                            ></feature-fault>
                        </b-col>
                    </b-row>
                </div>
                <!-- </div> -->
            </div>
            <!-- </b-container> -->

            <div class="container-fluid">
                <!-- <div class="lines-left"></div> -->
                <!--
                <div class="cont-section-3">
                    <b-row no-gutters class="row-section-3">
                        <img
                            src="/images/Pose-1-no-shadow-min.png"
                            class="scuirel-mdl"
                            alt=""
                        />
                        <b-col cols="12">
                            <div class="sec-3 title-sections text-left">
                                options academy
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="sub-title-sections sec-2 text-left ">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua.
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua.
                            </div>
                        </b-col>
                        <b-col cols="12">
                            <div class="btn-section">
                                <button
                                    class="btn btn-primary btn-home learn"
                                    type="button"
                                    style="padding: 0 8px;"
                                >
                                    learn more
                                </button>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                -->
                <div class="cont-section-2">
                    <b-row no-gutters class="row-section-2">
                        <b-col cols="12">
                            <div class="title-section-2">Audited By</div>
                        </b-col>
                        <b-col
                            cols="12"
                            style="margin-top: 41px; position: relative"
                        >
                            <audited-by />
                        </b-col>
                    </b-row>
                </div>
                <div class="cont-section-2">
                    <b-row no-gutters class="row-section-2">
                        <b-col cols="12">
                            <div class="title-section-2">Our Partners</div>
                        </b-col>
                        <b-col
                            cols="12"
                            style="margin-top: 41px; position: relative"
                        >
                            <our-partners />
                        </b-col>
                    </b-row>
                </div>
                <div class="cont-section-2 cont-3">
                    <b-row no-gutters class="row-section-2">
                        <b-col cols="12">
                            <banner-box
                                :itemBanner="itemBan"
                                target="_blank"
                            ></banner-box>
                        </b-col>
                    </b-row>
                </div>
                <div class="cont-section-2">
                    <b-row no-gutters class="row-section-2">
                        <b-col cols="12">
                            <div class="title-section-2">our community</div>
                        </b-col>
                        <b-col
                            cols="12"
                            style="margin-top: 41px; position: relative"
                        >
                            <!-- <img
              src="/images/ice_age_bottom.png"
              class="scuirel-btm my-nuts bounce"
              alt=""
              /> -->
                            <social-box :itemSocial="itemSoc"></social-box>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import statItem from "../components/stat-item.vue";
import socialBox from "../components/socialBox.vue";
import bannerBox from "../components/bannerBox.vue";
import featureFault from "../components/featureFault.vue";
import OurPartners from "../components/OurPartners.vue";
import AuditedBy from "../components/AuditedBy.vue";

import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            vaults: null,
            itemStats: [
                {
                    icon: "/images/icons/bank.svg",
                    title: "",
                    subTitle: "Total Value Locked"
                },
                {
                    icon: "/images/icons/user.svg",
                    title: "",
                    subTitle: "Total Users"
                }
            ],
            itemSoc: [
                {
                    icon: "/images/icons/discord.svg",
                    title: "discord",
                    subTitle: "chat in real time with the theta nuts community",
                    link: "https://dsc.gg/thetanuts"
                },
                {
                    icon: "/images/icons/github.svg",
                    title: "github",
                    subTitle: "follow our github for updates",
                    link: "https://github.com/Theta-Nuts"
                },
                {
                    icon: "/images/icons/medium.svg",
                    title: "medium",
                    subTitle: "follow us on Medium",
                    link: "https://thetanuts.medium.com/"
                },
                {
                    icon: "/images/icons/twitter.svg",
                    title: "twitter",
                    subTitle: "follow @thetanuts for updates and news",
                    link: "https://twitter.com/ThetanutsFi"
                }
            ],
            itemBan: [
                {
                    img: "/images/bg-banner-2.png",
                    title: "developer docs",
                    subTitle: "guides, references and more.",
                    link: "https://thetanuts.gitbook.io/thetanuts"
                }
            ],
            itemBanTwo: [
                {
                    img: "/images/bg-banner-1.png",
                    title: "financial nfts",
                    subTitle: "coming soon",
                    link: "#"
                }
            ]
        };
    },
    computed: {
        ...mapGetters({
            chainId: "wallet/getChainId",
            hasWallet: "wallet/getHasWallet"
        }),
        getFeatured() {
            return this.vaults.sort((a, b) => b.apy - a.apy).slice(0, 4);
        }
    },
    watch: {
        "$store.state.vaults.vaults": {
            handler: function(nv) {
                this.vaults = nv;
            }
            //immediate: true // provides initial (not changed yet) state
        },
        chainId(newChainId, oldChainId) {
            this.getAllVaults(newChainId);
        },
        hasWallet(v) {
            let chainId = this.chainId;
            if (!v) chainId = "all";
            this.getAllVaults(chainId);
        }
    },
    components: {
        statItem,
        socialBox,
        bannerBox,
        featureFault,
        OurPartners,
        AuditedBy
    },
    methods: {
        ...mapActions({
            getAllVaults: "vaults/getAllVaults",
            // connectWithMetamask: "wallet/connectWithMetamask"
        })
    },
    async mounted() {
        await this.getAllVaults(this.chainId);
        // if (!this.hasWallet) await this.connectWithMetamask();
    }
};
</script>
<style lang="scss">
@import "./resources/sass/app.scss";

.first-wave {
    /* background: url("/images/first_wave.png") no-repeat; */
    background-size: cover;
    padding-bottom: 6.94445vw;
    background-position: bottom;
}
.leaf-home {
    position: absolute !important;
    min-height: unset !important;
}
.leaf-bottom {
    position: absolute !important;
    min-height: unset !important;
}
.cont-land {
    position: relative;
    height: 100%;
    width: 100%;
    margin: auto;
    padding: 0 5px;
    margin-bottom: 30px;
    .cont-section {
        display: flex;
        // min-height: 540px;
        min-height: calc(66vw / 1.9);
        .row-section {
            // max-width: 1110px;
            width: 77vw;
            margin: auto;
            // padding: 0 145px;
        }
        .item-list-box {
            margin-top: 50px;
        }
    }
    .cont-section-2 {
        display: flex;
        padding: 2.08333vw 0;
        .row-section-2 {
            width: 90vw;
            // max-width: 1110px;
            margin: auto;
        }
    }
    .cont-3 {
        padding: 40px 0 !important;
    }
    .cont-section-3 {
        margin-top: 2.08333vw;
        display: flex;
        min-height: 27.084vw;
        .row-section-3 {
            position: relative;
            width: 77vw;
            // max-width: 1110px;
            margin: auto;
            padding: 0 5%;
        }
    }
    .title-sections {
        font-family: Bungee;
        font-style: normal;
        font-weight: normal;
        font-size: 3.055556vw; //$section-title;
        line-height: 53px;
        text-align: center;
        letter-spacing: 0.04em;
        color: $primary-4;
    }
    .sec-3 {
        color: transparent !important;
        background-image: -webkit-$gradient-1;
        background-image: -moz-$gradient-1;
        background-image: -ms-$gradient-1;
        background-image: -o-$gradient-1;
        background-image: $gradient-1;
        -webkit-background-clip: text;
        background-clip: text;
    }
    .sub-title-sections {
        margin-top: 28px;
        width: 50%;
        font-family: Exo;
        font-style: normal;
        font-weight: bold;
        font-size: 1.25vw; //$section-text;
        // line-height: 29px;
        line-height: calc(1.25vw + 10px);
        text-transform: uppercase;
        color: $primary-4;
        &.sec-2 {
            width: 55%;
        }
    }
    .title-section-2 {
        font-family: Bungee;
        font-style: normal;
        font-weight: normal;
        // font-size: 38px;
        font-size: $section-title-2;
        // line-height: 46px;
        line-height: calc(#{$section-title-2} + 10px);
        text-align: center;
        letter-spacing: 0.04em;
        color: $primary-4;

        @media only screen and (min-width: 1440px) {
            font-size: 38px;
            line-height: 45px;
        }
    }
    .btn-section {
        display: flex;
        width: 35%;
        margin-top: 1.945vw;
        gap: 20px;
    }
    .btn-home {
        width: 16.667vw; //$btn-normal-vw;
        height: calc(16.667vw / 6);
        border-radius: 16vh !important;
        &.learn {
            width: 12.5vw;
        }
    }
    // .scuirel-btm {
    //   position: absolute;
    //   width: 9.5vw;
    //   height: calc(9.5vw / 1.3);
    //   // width: 137.21px;
    //   // height: 144.29px;
    //   // left: 18%;
    //   // bottom: 77%;
    //   z-index: 1;
    // }
    .scuirel-mdl {
        position: absolute;
        // width: 450px;
        width: 30vw;
        // height: 450px;
        right: -6%;
        bottom: -10%;
        z-index: 1;
    }
    .scuirel-top-3 {
        position: absolute;
        // width: 113px;
        // height: 155px;
        width: 9.2vw;
        transform: translate(0%, -50%);
        right: 0;
        top: 175px;
        z-index: 1;
    }
    .scuirel-top-4 {
        position: absolute;
        // width: 70px;
        // height: 64px;
        transform: translate(0%, -50%);
        // right: 13%;
        top: 360px;
        right: 13vw;
        z-index: 1;
    }
    .scuirel-top-1 {
        position: absolute;
        width: 38vw; //9.5vw;
        height: 38vw;
        transform: translate(0%, -50%);
        top: 15vw;
        z-index: 1;
        right: 7vw;
        /*
        position: absolute;
        width: 251.2px;
        height: 489.6px;
        transform: translate(0%, -50%);
        // right: 19%;
        top: 235px;
        z-index: 1;
        // width: 21.6vw;
        // height: calc(21.6vw/0.5);
        // top: calc(21.6vw/0.5/2 + -7px);
        right: 20vw;
        */
    }
    .scuirel-top-2 {
        position: absolute;
        // width: 150px;
        // height: 135px;
        transform: translate(0%, -50%);
        // right: 33%;
        top: 280px;
        width: 10.5vw;
        right: 35vw;
    }
    .box-fault {
        margin-top: 41px;
        padding: 0 45px;
    }
}
.bg-landing {
    width: 100%;
    height: auto;
    position: fixed;
    top: 0;
    left: 0;
}
.sub-cont {
    max-width: 1110px;
}
.bg-land {
    image-rendering: auto;
    image-rendering: crisp-edges;
    image-rendering: pixelated;
    position: absolute;
    left: 0;
    transform: translate(-50%, 0);
    bottom: 0;
    width: 100% !important;
    height: 100% !important;
    object-fit: cover;
}
.top-blob {
    background: url("/images/full_top_group.svg") no-repeat top right;
    background-size: contain;
    // background-size: cover;
    // width: -webkit-fit-content;
    // width: -moz-fit-content;
    // width: fit-content;
    position: absolute;
    right: 0;
    top: -6.112vw;
    // top: -88px;
    // max-width: 40%;
    // min-width: 648px;
    // min-height: 666px;
    width: 47vw;
    // height: 82vh;
    height: calc(47vw / 0.7);
}
.lines-left {
    background: url("/images/lines-left.svg") no-repeat center left;
    background-size: contain;
    // width: -moz-fit-content;
    // width: fit-content;
    position: absolute;
    left: 0px;
    // top: 1400px;
    // max-width: 40%;
    // min-width: 158px;
    // min-height: 614px;
    // min-width: 11vw;
    // min-height: 55vh;
    // width: 14.3vw;
    width: 10.3vw;
    // height: 100.7vh;
    height: calc(10.3vw * 3.95);
    margin-top: -350px;
}
.lines-right {
    // background: url('/images/lines-right.svg') no-repeat center right;
    background: url("/images/lines-right.svg") no-repeat center right;
    background-size: contain;
    // width: -moz-fit-content;
    // width: fit-content;
    position: absolute;
    right: 0px;
    // top: 800px;
    // max-width: 40%;
    // min-width: 1292px;
    // min-height: 1317px;
    top: 40vw; //60vmin;
    width: 89vw;
    height: calc(89vw / 0.9);
}
.lines-bottom {
    background: url("/images/lines-bottom.png") no-repeat;
    background-size: cover;
    // width: -moz-fit-content;
    // width: 100%;
    position: absolute;
    right: 0px;
    bottom: 200px;
    // max-width: 100%;
    // min-width: 1292px;
    // min-height: 300px;
    // min-width: 11vw;
    // min-height: 55vh;
    width: 100vw;
    height: calc(100vw / 5.4);
    opacity: 0.6;
}
@media screen and (max-width: 1900px) {
    .cont-land {
        .cont-section {
            min-height: calc(66vw / 1.9);
        }
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .cont-land {
        padding: 0;
        .cont-section {
            min-height: 425px !important;
            .row-section {
                padding: 0 !important;
                width: 100%;
                .item-list-box {
                    margin-top: 3.4723vw;
                }
            }
        }
        .cont-section-2 {
            padding: 20px 0;
            .row-section-2 {
                width: 100%;
            }
        }
        .title-sections {
            font-size: 26px !important;
            line-height: 31px !important;
        }
        .sub-title-sections {
            width: 100% !important;
            font-size: 14px !important; //$text-normal
            line-height: 20px !important;
        }
        .btn-section {
            width: 100%;
            gap: 0 !important;
        }
        .title-section-2 {
            font-size: 20px !important;
            line-height: 24px !important;
        }
        .cont-section-3 {
            min-height: 300px;
            .row-section-3 {
                padding: 0 !important;
            }
        }
        .box-fault {
            margin-top: 41px;
            padding: 0 !important;
        }
        .btn {
            min-width: 130px !important;
            font-size: 12px !important;
            padding: 10px !important;
        }
        .scuirel-btm {
            display: none;
        }
        .scuirel-mdl {
            width: 161px !important;
            height: 161px !important;
            left: 87% !important;
            top: 117% !important;
            bottom: 0;
            right: 0;
            transform: translate(-50%, -50%);
            z-index: -1;
        }
        .scuirel-top-3 {
            width: 30.89px;
            height: 27.91px;
            right: 0%;
            top: 26px;
            z-index: 1;
        }
        .scuirel-top-4 {
            width: 13.74px;
            height: 12.42px;
            right: 2%;
            top: 57px;
        }
        .scuirel-top-1 {
            width: 100px;
            height: 100px;
            right: 6%;
            top: 50px;
            z-index: 1;
        }
        .scuirel-top-2 {
            width: 14.68px;
            height: 13.27px;
            right: 14%;
            top: 47px;
        }
        .btn-home {
            height: 32px;
        }
    }
    .first-wave {
        padding: 0px 20px !important;
    }
    .top-blob {
        top: -60px !important;
    }
}
</style>
